import React from 'react';

const Caret = props => (
	<svg width="13" height="8" viewBox="0 0 13 8" fillRule="evenodd" stroke="#38BFC3" fill="#38BFC3" {...props}>
		<path d="M6.5 7a.654.654 0 0 1-.457-.185L1.19 2.078a.62.62 0 0 1 0-.893.658.658 0 0 1 .914 0L6.5 5.476l4.396-4.291a.658.658 0 0 1 .914 0 .62.62 0 0 1 0 .893L6.957 6.815A.654.654 0 0 1 6.5 7z"/>
	</svg>
);

export default Caret;
